import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class RoleAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Auth";
  controllerName = "api/roles";

  /**
   * Lấy dữ liệu danh sách
   */
  getList() {
    let request = {
      url: this.getAPIUrl(),
      //data: param
    };
    return httpClient.getAsync(request);
  }

  // Lấy danh sách permission mặc định
  getListPermissions() {
    let request = {
      url: window._apis.Auth + "/api/permissions",
    };
    return httpClient.getAsync(request);
  }

  // Lấy danh sách permission theo role
  getListPermissionsByRole(role) {
    let request = {
      url: window._apis.Auth + `/api/permissions/role?roleName=${role}`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách người dùng theo vai trò dùng trên danh sách vai trò
   */
  getListUserByRoleID(roleID) {
    let request = {
      url: [this.getAPIUrl() + "api/users", roleID].join("/"),
    };
    return httpClient.getAsync(request, false, false);
  }

  /**
   * Thêm role
   */
  insertRole(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * sửa role
   */
  updateRole(payload, id) {
    let request = {
      url: [this.getAPIUrl(), id].join("/"),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa role
   */
  delete(record) {
    let request = {
      url: window._apis.Auth + "/api/roles/" + record.Entity[0].id,
    };
    return httpClient.deleteAsync(request);
  }

  /**
   * Thêm permission mới cho người dùng
   */
  createPermission(payload) {
    let request = {
      url: window._apis.Auth + "/api/permissions",
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new RoleAPI();
